import { render } from "./MiniRateCard.vue?vue&type=template&id=8c53d32e&scoped=true"
import script from "./MiniRateCard.vue?vue&type=script&lang=js"
export * from "./MiniRateCard.vue?vue&type=script&lang=js"

import "./MiniRateCard.vue?vue&type=style&index=0&id=8c53d32e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\LifeInsureance\\web\\LifeInsurance\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c53d32e"]])

export default __exports__